import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserExperienceImprovementFeedbackModalComponent } from 'src/app/shared/components/user-experience-improvement-feedback-modal/user-experience-improvement-feedback-modal.component';
import { FeedbackType } from 'src/app/shared/enums/user-app-experience.enum';
import { UserFeedbackService } from 'src/app/shared/services/user.feedback.service';

declare let cordova: any;
@Component({
  selector: 'app-user-experience-feedback-modal',
  templateUrl: './user-experience-feedback-modal.component.html',
})
export class UserExperienceFeedbackModalComponent {
  constructor(
    private modalCtrl: ModalController,
    private userFeedbackService: UserFeedbackService,
  ) {}

  openFeedbackModal(): void {
    this.modalCtrl
      .create({
        component: UserExperienceImprovementFeedbackModalComponent,
      })
      .then(async (modalRef: HTMLIonModalElement) => {
        await modalRef.present();

        modalRef.onDidDismiss().then(() => {
          this.modalCtrl.dismiss();
        });
      });
  }

  async dismiss(): Promise<void> {
    try {
      await this.userFeedbackService.storeUserFeedback({
        attributes: {
          response: FeedbackType.POSITIVE,
        },
      });
      cordova?.plugins?.AppReview.requestReview();
    } catch (error) {
      // suppressing error
      console.error('[Failed to store user feedback]', error);
    }
    this.modalCtrl.dismiss();
  }
}
